import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DownOutlined, LogoutOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useStores } from "../../../../store/stores.js";
import { __ } from "../../../../utils/i18n.js";
import { MATOMO_MASK } from "../../../../utils/matomoMask.js";
const UserPill = observer(()=>{
    const { accountV2Store } = useStores();
    const navigate = useNavigate();
    const [isGravatarUnblocked, setIsGravatarUnblocked] = useState(false);
    const [isGravatarLoaded, setIsGravatarLoaded] = useState(false);
    useEffect(()=>{
        // Each path falls through to the initial-letter fallback unless the
        // consent API explicitly resolves the Gravatar host:
        //   • No consent API (no Real Cookie Banner on the page) → letter
        //   • Consent API present, customer denied → letter (unblock rejects)
        //   • Consent API present, customer accepted → swap to Gravatar
        const { consentApi } = window;
        if (!consentApi) {
            return;
        }
        consentApi.unblock("gravatar.com/avatar").then(()=>setIsGravatarUnblocked(true), ()=>undefined);
    }, []);
    const user = accountV2Store.session?.user;
    if (!user) {
        return null;
    }
    const { firstName, email, emailMd5 } = user;
    const initial = (firstName || email).trim().charAt(0).toUpperCase() || "?";
    // Dropdown only carries actions — the email is already visible on the
    // pill itself, no need to repeat it here.
    const items = [
        {
            key: "logout",
            icon: /*#__PURE__*/ _jsx(LogoutOutlined, {}),
            label: __("Sign out"),
            onClick: ()=>{
                accountV2Store.signOut();
                navigate("/");
            }
        }
    ];
    return /*#__PURE__*/ _jsx(Dropdown, {
        menu: {
            items
        },
        placement: "bottomRight",
        trigger: [
            "click"
        ],
        overlayClassName: "rc-account-v2-hero__user-pill-dropdown",
        children: /*#__PURE__*/ _jsxs("button", {
            type: "button",
            className: "rc-account-v2-hero__user-pill",
            "aria-label": __("Account menu"),
            children: [
                /*#__PURE__*/ _jsxs("span", {
                    className: "rc-account-v2-hero__user-pill-avatar-wrap",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            "aria-hidden": true,
                            className: "rc-account-v2-hero__user-pill-avatar rc-account-v2-hero__user-pill-avatar--initial",
                            children: initial
                        }),
                        isGravatarUnblocked && /*#__PURE__*/ _jsx("img", {
                            className: `rc-account-v2-hero__user-pill-avatar rc-account-v2-hero__user-pill-avatar--image${isGravatarLoaded ? " rc-account-v2-hero__user-pill-avatar--loaded" : ""}`,
                            alt: "",
                            src: `https://www.gravatar.com/avatar/${emailMd5}?d=mp&s=60`,
                            onLoad: ()=>setIsGravatarLoaded(true),
                            ...MATOMO_MASK
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("span", {
                    className: "rc-account-v2-hero__user-pill-text",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "rc-account-v2-hero__user-pill-name",
                            children: __("Hey %s!", firstName)
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "rc-account-v2-hero__user-pill-email",
                            ...MATOMO_MASK,
                            children: email
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(DownOutlined, {
                    className: "rc-account-v2-hero__user-pill-caret",
                    "aria-hidden": true
                })
            ]
        })
    });
});
export { UserPill };
